// NavigationOptions interface changed in Ionic 7
// Using AnimationDirection enum from @ionic/core
import { AnimationDirection } from '@ionic/core';

export const navRootOptions = {
  animated: true,
  animationDirection: 'back' as AnimationDirection
}
